import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';

export const ProductsWrap = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 2)};
  `}
`;

export const AlreadyInBagText = styled(Typography)`
  width: 100%;
  text-align: center;
`;

export const LinkButton = styled(LegacyButton)`
  gap: 0;
  svg {
    path {
      transition: color 0.3s;
    }
  }

  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
    text-underline-offset: 0.25em;
    &:hover {
      svg {
        path {
          color: ${theme.colors.primary};
        }
      }
    }
  `}
`;

export const Buttons = styled(Box)<{
  $isAddWarranty?: boolean;
}>`
  ${({ theme }) => css`
    & > button {
      border-bottom: 1px solid ${theme.colors.primaryAdd6};

      ${theme.media.md.up} {
        &:last-child {
          border-bottom: none;
          margin-bottom: 16px;
        }
      }
    }

    & > button {
      border-top: 1px solid ${theme.colors.primaryAdd6};
    }

    ${theme.media.md.down} {
      margin-inline: -${theme.spacing(2)};
    }

    ${theme.media.md.up} {
      padding-left: ${theme.spacing(0)};

      & > button {
        padding-left: 0;
      }
    }
  `}
`;

export const Notice = styled(Typography)`
  line-height: 1.25;

  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes.p3};
    padding: ${theme.spacing(1)};
    background-color: ${theme.colors.primaryLightAdd2};
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;
